export default "__VITE_ASSET__BCmbW5ZY__"